import { SocialEnum } from '../enums/SocialEnum';

export function capitalizeFirstLetter(text: string): string {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function levenshtein(a: string, b: string): number {
  const matrix: number[][] = Array.from({ length: b.length + 1 }, (_, i) =>
    Array.from({ length: a.length + 1 }, (_, j) =>
      i === 0 ? j : j === 0 ? i : 0
    )
  );

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

const commonEmailDomains = [
  'gmail.com',
  'outlook.com',
  'hotmail.com',
  'yahoo.com',
  'icloud.com'
];

export function isEmailDomainPossiblyMisspelled(email: string): boolean {
  const parts = email.split('@');
  if (parts.length !== 2) return false;

  const domain = parts[1].toLowerCase();

  if (commonEmailDomains.includes(domain)) return false;

  let closestMatch = '';
  let shortestDistance = Infinity;

  for (const known of commonEmailDomains) {
    const distance = levenshtein(domain, known);
    if (distance < shortestDistance) {
      shortestDistance = distance;
      closestMatch = known;
    }
  }

  if (shortestDistance <= 2 && domain.length >= closestMatch.length - 2)
    return true;

  return false;
}

export function getEmailProvider(email: string): SocialEnum | null {
  const domain = email.split('@')[1]?.toLowerCase();

  if (!domain) return null;

  if (['gmail.com'].includes(domain)) return SocialEnum.GOOGLE;
  if (['outlook.com', 'hotmail.com'].includes(domain))
    return SocialEnum.MICROSOFT;
  if (['icloud.com'].includes(domain)) return SocialEnum.APPLE;

  return null;
}

export function getFirstName(fullName: string): string {
  const names = fullName.trim().split(' ');
  return names[0] || '';
}
